import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import schoolImage from "../../assets/images/school.jpg";
import AlertMessage from "../../AlertMessage";
import CreatePramanNode from "../Poshanaahar/CreatePramanNode";
import ThankYoupage from "./ThankYoupage";

function SchoolregNoOTP() {
  const [schoolName, setSchoolName] = useState("");
  const [udiseNumber, setUdiseNumber] = useState("");
  const [password, setPassword] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [language, setLanguage] = useState(localStorage.getItem("language"));
  const [showLanguageOverlay, setShowLanguageOverlay] = useState(!localStorage.getItem("language"));
  const [telephoneNumber, setTelephoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [taluka, setTaluka] = useState("");
  const [jilha, setJilha] = useState("");
  const [email, setEmail] = useState("");
  const [sansthaName, setsansthaName] = useState("");
  const [bridvakya, setbridvakya] = useState("");
  const [boardName, setBoardName] = useState("");
  const [indexNumber, setIndexNumber] = useState("");
  const [schoolCode, setSchoolCode] = useState("");
  const [sanlagnataKramank, setSanlagnataKramank] = useState("");
  const [manyataKramank, setManyataKramank] = useState("");
  const [madhyam, setMadhyam] = useState("");
  const [schoolLogo, setSchoolLogo] = useState("");
  const [schoolLogo2, setSchoolLogo2] = useState("");
  const [userStatus, setuserStatus] = useState("Deactive");
  const [price, setPrice] = useState("");
  const [salesConsultant, setsalesConsultant] = useState("");
  const [activationDate, setactivationDate] = useState("");
  const registerDate = new Date().toISOString().split('T')[0];
  const [boardType, setboardType] = useState("");
  const [showThankYoupage, setShowThankYoupage] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [invalidMobileNumber, setInvalidMobileNumber] = useState(false);
  const [isFormFilled, setIsFormFilled] = useState(false);

  useEffect(() => {
    setIsFormFilled(!!schoolName && !!udiseNumber && !!password && !!mobileNumber);
  }, [schoolName, udiseNumber, password, mobileNumber]);

  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage(""); // clear the alert message
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);

  useEffect(() => {
    if (!language) {
      setShowLanguageOverlay(true);
    }
  }, [language]);

  useEffect(() => {
    if (language) {
      localStorage.setItem("language", language);
    }
  }, [language]);

  const handleLanguageChange = (e) => {
    const selectedLanguage = e.target.value;
    setLanguage(selectedLanguage);
    localStorage.setItem("language", selectedLanguage);
    setShowLanguageOverlay(false);
  };

  const handleRegistration = (e) => {
    e.preventDefault();
    
    // Check if UDISE number already exists
    fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}.json`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data !== null) {
          setAlertMessage(language === "English" ? "You have already registered with this UDISE number. Please try forget password option with mobile number." : "आपण या UDISE क्रमांकद्वारे आधीच नोंदणी केली आहे. कृपया मोबाइल नंबरसह विसरलेला पासवर्ड विसरा पर्याय वापरा.");
          return;
        }

        // Check if mobile number already exists
        fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/user/${mobileNumber}.json`)
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then((data) => {
            const schoolData = {
              schoolName,
              password,
              mobileNumber,
              language,
              telephoneNumber,
              address,
              taluka,
              jilha,
              email,
              sansthaName,
              bridvakya,
              boardName,
              boardType,
              indexNumber,
              schoolCode,
              sanlagnataKramank,
              manyataKramank,
              madhyam,
              schoolLogo,
              schoolLogo2,
              userStatus,
              salesConsultant,
              activationDate,
              registerDate: new Date().toISOString().split('T')[0],
              price,
              udiseNumber: udiseNumber,
            };

            const userData = {
              mobileNumber,
              password,
              schoolName,
              udiseNumber,
              status: "DKglzhgYFYTDT141414HGCkkgfs22117785YFUTFybnujghhgtghghYFYVNOmC234567Omgkysfgvghyfjhyfvv56764",
            };

            const schoolRegisterData = {
              schoolData,
              studentData: {},
            };

            // Calculate dates for admin data
            const currentDate = new Date().toISOString().split('T')[0];
            const deactivationDate = new Date();
            deactivationDate.setDate(deactivationDate.getDate() + 7);
            const formattedDeactivationDate = deactivationDate.toISOString().split('T')[0];

            // Add this section to save required data under Admin node
            const adminData = {
              schoolName,
              mobileNumber,
              registerDate: currentDate,
              userStatus: "Active",
              activationDate: currentDate,
              deactivationDate: formattedDeactivationDate,
              packActivated: "freeTrial",
              salePersonName: "BySelf",
              finalPrize: "00",
              paidAmount: "00"
            };

            // Create a fetch request to save data under Admin node
            fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/Admin/${udiseNumber}.json`, {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(adminData),
            })
              .then((response) => {
                if (!response.ok) {
                  throw new Error("Network response was not ok while saving admin data");
                }
                return response.json();
              })
              .catch((error) => {
                console.error("Error saving admin data:", error);
              });

            if (data !== null) {
              const uniqueKey = new Date().getTime().toString(); 
              fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/user/${mobileNumber}/${uniqueKey}.json`, {
                method: "PUT",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(userData),
              })
                .then((response) => {
                  if (!response.ok) {
                    throw new Error("Network response was not ok while saving additional data");
                  }
                  return response.json();
                })
                
            } else {
              // Mobile number does not exist: Store the data normally
              fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/user/${mobileNumber}.json`, {
                method: "PUT",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(userData),
              })
                .then((response) => {
                  if (!response.ok) {
                    throw new Error("Network response was not ok while saving user data");
                  }
                  return response.json();
                })
                .then(() => {
                  CreatePramanNode(udiseNumber, language);
                  setAlertMessage(language === "English" ? "Registered successfully." : "यशस्वीरित्या नोंदणी केली.");
                });
            }
            
            // Store school data in schoolRegister node
            fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}.json`, {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(schoolRegisterData),
            })
              .then((response) => {
                if (!response.ok) {
                  throw new Error("Network response was not ok");
                }
                return response.json();
              })
              .then(() => {
                CreatePramanNode(udiseNumber, language);
                setShowThankYoupage(true)
              });
          })
          .catch((error) => {
            console.error("Error checking mobile number:", error);
          });
      })
      .catch((error) => {
        console.error("Error checking UDISE number:", error);
      });
  };

  const handleChangeBoard = (e) => {
    setboardType(e.target.value)
  }

  return (
    <div className="p-5 mt-2">
      {showLanguageOverlay && (
        <div className="overlay" style={{ display: 'flex', width: '100%' }}>
          <div
            className="sidebar-template"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              maxHeight: '88vh',
              background: 'linear-gradient(135deg, #eaeff3, #3acad1)',
              padding: '15px 10px',
              borderRadius: '20px',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.15)',
              animation: 'fadeIn 1s ease-in-out',
              marginTop: '35px',
            }}
          >
            <div
              className="card"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '20px',
                animation: 'slideIn 1s ease-in-out',
                background: '#fff',
                border: '1px solid #e0e0e0',
                borderRadius: '20px',
                boxShadow: '0 8px 20px rgba(0, 0, 0, 0.1)',
                marginTop: '40px',
                maxHeight: '85vh',
                overflowY: 'scroll',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none'
              }}
            >
              <div
                className="column english"
                style={{
                  flex: 1,
                  padding: '10px',
                  backgroundColor: '#ffffff',
                  borderRadius: '20px',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  animation: 'bounceIn 1.5s ease-in-out'
                }}
              >
                <h3
                  style={{
                    color: '#007bff',
                    marginBottom: '15px',
                    fontFamily: "'Poppins', sans-serif",
                    fontSize: '1.8em',
                    textAlign: 'center',
                    borderBottom:'2px solid  #ff7043',
                    paddingBottom:'10px'
                  }}
                >
                <b>Smart Guruji Software</b>
                  
                </h3>
                <p
                  style={{
                    fontSize: '14px',
                    lineHeight: '1.6',
                    fontFamily: "'Roboto', sans-serif",
                    color: '#333',
                    textAlign: 'center'
                  }}
                >
                  With this software, you can register your school, manage school information, and more. <br/><b>Please select your language to continue. You will be able to use the software in the selected language.</b>
                </p>
                <ol
                  style={{
                    paddingLeft: '20px',
                    marginTop: '20px',
                    fontFamily: "'Roboto', sans-serif",
                    color: '#007bff'
                  }}
                >
                  <li style={{ marginBottom: '10px' }}>Manage your school's information</li>
                  <li style={{ marginBottom: '10px' }}>Register students, fill in or update information</li>
                  <li style={{ marginBottom: '10px' }}>Bonafide</li>
                  <li style={{ marginBottom: '10px' }}>School leaving certificate</li>
                  <li style={{ marginBottom: '10px' }}>Student identification card</li>
                  <li style={{ marginBottom: '10px' }}>Various types of reports and much more</li>
                  <li style={{ marginBottom: '10px' }}>Available in Marathi and English Language</li>
                </ol>
              </div>
              <div
                className="column marathi"
                style={{
                  flex: 1,
                  padding: '25px 17px',
                  backgroundColor: '#ffffff',
                  borderRadius: '20px',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  animation: 'bounceIn 1.5s ease-in-out',
                  width:'98%',
                  marginTop:'-20px'
                }}
              >
                <h3
                  style={{
                    color: '#007bff',
                    marginBottom: '15px',
                    fontFamily: "'Poppins', sans-serif",
                    fontSize: '1.8em',
                    textAlign: 'center',
                    marginTop: '-15px',
                    borderBottom:'2px solid  #ff7043',
                    paddingBottom:'10px'
                  }}
                >
                <b>स्मार्ट गुरुजी सॉफ्टवेअर</b>
                  
                </h3>
                <p
                  style={{
                    fontSize: '14px',
                    lineHeight: '1.6',
                    fontFamily: "'Roboto', sans-serif",
                    color: '#333',
                    textAlign: 'center'
                  }}
                >
                  या सॉफ्टवेअरद्वारे आपण आपल्या शाळेची नोंदणी करू शकता, शाळेची माहिती व्यवस्थापित करू शकता आणि अधिक.<br/> <b>कृपया पुढे चालू ठेवण्यासाठी आपली भाषा निवडा. निवडलेल्या भाषेत तुम्हाला हे सॉफ्टवेअर वापरण्यास मिळेल.</b>
                </p>
                <ol
                  style={{
                    paddingLeft: '20px',
                    marginTop: '20px',
                    fontFamily: "'Roboto', sans-serif",
                    color: '#007bff',
                  }}
                >
                  <li style={{ marginBottom: '10px' }}>आपल्या शाळेची माहिती व्यवस्थापित करा</li>
                  <li style={{ marginBottom: '10px' }}>विद्यार्थी नोंदणी करा, माहिती भरा किंवा अपडेट करा.</li>
                  <li style={{ marginBottom: '10px' }}>बोनफाईड</li>
                  <li style={{ marginBottom: '10px' }}>शाळा सोडल्याचा दाखला</li>
                  <li style={{ marginBottom: '10px' }}>विद्यार्थी ओळख पत्र</li>
                  <li style={{ marginBottom: '10px' }}>विविध प्रकारचे रीपोर्ट आणि बरेच काही</li>
                  <li style={{ marginBottom: '10px' }}>मराठी आणि इंग्रजी भाषेत उपलब्ध</li>
                </ol>
              </div>
            </div>
          </div>
          <div
            className="center-content"
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '20px',
              marginLeft: 'auto'
            }}
          >
            <div
              className="language-box"
              style={{
                textAlign: 'center',
                backgroundColor: 'rgb(243, 238, 238)',
                width: '300px !important',
                padding: '40px 35px',
                borderRadius: '5px',
                boxShadow: '2px 0 5px rgba(0, 0, 0, 0.1)'
              }}
            >
              <h4 style={{ marginTop: '-30px' }}>Select Language</h4>
              <select
                className="form-select"
                style={{ width: '100%' }}
                value={language || ''}
                onChange={handleLanguageChange}
              >
                <option value="">Select Language</option>
                <option value="English">English</option>
                <option value="Marathi">मराठी</option>
              </select>
            </div>
          </div>
        </div>
      )}

      <div className={`schoolRegisterForm col-md-5 col-sm-12 mb-4 p-md-4 ${showLanguageOverlay ? 'blur-background' : ''}`}>
        <h1 className="my-2">
          {language === "English" ? " Register Your School" : "शाळा नोंदणी करा"}
        </h1>
        <AlertMessage message={alertMessage} show={showAlert} />
        <div className="row my-3 sc-form">
          <div className="col-md-4 col-sm-12 mt-md-5">
            <img className="img-fluid mt-5" src={schoolImage} alt="School" />
          </div>

          <div className="col-md-8 col-sm-12">
            <form className="h-100 text-start p-4 mb-4">
              <div>
                <label htmlFor="schoolName">
                  {language === "English" ? "School Name" : "शाळेचे नाव"}
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={language === "English" ? "Enter school name" : "शाळेचे नाव प्रविष्ट करा"}
                  id="schoolName"
                  value={schoolName}
                  onChange={(e) => setSchoolName(e.target.value)}
                  required
                />
              </div>

              <div>
                <label htmlFor="udiseNumber">
                  {language === "English" ? "UDISE Number" : "UDISE क्रमांक"}
                </label>
                <input
                  type="number"
                  className="form-control"
                  placeholder={language === "English" ? "Enter UDISE number" : "UDISE क्रमांक प्रविष्ट करा"}
                  id="udiseNumber"
                  value={udiseNumber}
                  onChange={(e) => setUdiseNumber(e.target.value)}
                  required
                />
              </div>
              <div>
                <label htmlFor="BoardType">
                  {language==='English' ? "Board Type" : "बोर्ड प्रकार"}
                </label>
                <select className="form-control" id="boardType" value={boardType} onChange={handleChangeBoard} >
                  <option value="">{language === "English" ? "Select Board Type" : "बोर्ड प्रकार निवडा"}</option>
                  <option value="icse">ICSE</option>
                  <option value="cbse">CBSE</option>
                  <option value="stateBoard">State Board</option>
                </select>
              </div>

              <div>
                <label htmlFor="password">
                  {language === "English" ? "Password" : "पासवर्ड"}
                </label>
                <input
                  type="password"
                  className="form-control"
                  placeholder={language === "English" ? "Enter password" : "पासवर्ड प्रविष्ट करा"}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              <div>
                <label htmlFor="mobileNumber">
                  {language === "English" ? "Mobile Number" : "मोबाइल क्रमांक"}
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={language === "English" ? "Enter mobile number" : "मोबाइल क्रमांक प्रविष्ट करा"}
                  id="mobileNumber"
                  value={mobileNumber}
                  onChange={(e) => setMobileNumber(e.target.value)}
                  required
                />
                {invalidMobileNumber && (
                  <div className="invalid-feedback">
                    {language === "English" ? "Invalid mobile number" : "अवैध मोबाइल क्रमांक"}
                  </div>
                )}
              </div>

              <button
                type="submit"
                className="btn btn-primary mt-4"
                onClick={handleRegistration}
                disabled={!isFormFilled}
              >
                {language === "English" ? "Register" : "नोंदणी करा"}
              </button>
              <span className="loginLink mt-5">
                {language === "English"
                  ? "Already Registered ?"
                  : "आधीच नोंदणी केली आहे?"}
                <Link className="text-decoration-none ms-1" to="/">
                  {language === "English" ? "Just Login" : "लॉगिन करा"}
                </Link>
              </span>
            </form>
          </div>

          {showThankYoupage && (
            <ThankYoupage/>
          )}
        </div>
      </div>
    </div>
  );
}

export default SchoolregNoOTP;
